export default "__VITE_ASSET__DHHJOAYe__"